module.exports = __webpack_public_path__ + "img/select.fee307b3.svg";